import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import * as localStorageService from "../service/localStorageService";
import { LocalStorageKeys } from "../constants/localStorageKeys";
import { CommonConstants } from "../constants/commonConstants";

i18n.use(initReactI18next).init({
    fallbackLng: CommonConstants.DefaultLanguageCode,
    lng: localStorageService.getValue(LocalStorageKeys.Lang) != null ?
        localStorageService.getValue(LocalStorageKeys.Lang) : CommonConstants.DefaultLanguageCode,

    ns: ["translations"],
    defaultNS: "translations",
});

export default i18n;